import { Component, OnInit } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { FaIconComponent } from '@fortawesome/angular-fontawesome'
import { WjInputModule } from '@grapecity/wijmo.angular2.input'
import imageCompression, { Options } from 'browser-image-compression'

import { RepositoryModal, Right, Role, User } from '../../shared'

//import { WjListBox } from 'wijmo/wijmo.angular2.input';

@Component({
    templateUrl: './user.component.html',
    standalone: true,
    imports: [FormsModule, WjInputModule, FaIconComponent],
})
export class UserComponent extends RepositoryModal<User> implements OnInit {
    roles: Role[] = []
    rights: Right[] = []
    progress = 0
    imageToUpload!: any

    ngOnInit() {
        this.roles = this.services.data.roles.items.slice()
        this.roles.forEach(x => {
            if (this.target.rolesIds.indexOf(x.id) > -1) x['checked'] = true
            else x['checked'] = false
        })
        this.rights = this.services.data.rights.items.slice()
        this.rights.forEach(x => {
            if (this.target.rightsFromRightsIds.indexOf(x.id) > -1) x['checked'] = true
            else x['checked'] = false
        })
    }

    protected onBeforeSave() {
        this.target.rightsFromRightsIds = this.rights.filter(x => x['checked']).map(x => x.id)
        this.target.rolesIds = this.roles.filter(x => x['checked']).map(x => x.id)
        return super.onBeforeSave()
    }

    async onFileChanged(event) {
        // When the user picks an image, we will compress and store it locally.
        // It will get uploaded after the user is saved.
        const file = event.target.files[0]
        const progress = (p: number) => {
            this.progress = p
        }
        const options: Options = {
            maxSizeMB: 2,
            maxWidthOrHeight: 1920,
            useWebWorker: true,
            onProgress: progress,
        }
        this.imageToUpload = await imageCompression(file, options)
        this.target.imageUrl = await imageCompression.getDataUrlFromFile(this.imageToUpload)

        //If the saving of the record is successfult, we will upload any images.
        const uploadData = new FormData()
        uploadData.append('id', this.target.id)
        uploadData.append('myFile', this.imageToUpload, this.imageToUpload.name)
        this.services.data.post('api/User/UploadImage', uploadData).subscribe({
            next: () => (this.target.image = this.imageToUpload.name),
            error: () => this.services.notification.error('Image failed to upload.'),
        })
    }
}
